/*
Copyright 2015, 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

var React = require('react');

module.exports = React.createClass({
    displayName: 'ProgressBar',
    propTypes: {
        value: React.PropTypes.number,
        max: React.PropTypes.number
    },

    render: function() {
        // Would use an HTML5 progress tag but if that doesn't animate if you
        // use the HTML attributes rather than styles
        var progressStyle = {
            width: ((this.props.value / this.props.max) * 100)+"%"
        };
        return (
            <div className="mx_ProgressBar"><div className="mx_ProgressBar_fill" style={progressStyle}></div></div>
        );
    }
});



// WEBPACK FOOTER //
// ../../../../src/components/views/elements/ProgressBar.js